export interface IStopType {
    id: number,
    name: string
}

export enum StopType {
    PickUp = 1,
    Drop = 2,
    'PickUp & Drop' = 3
}